<div class="admin-page-grid">
    <div class="header-container">
        <div class="row-container">
            <div class="left-corner">
                <h1>{{ currPage.id ? currPage.id.toUpperCase() : '' }}</h1>
            </div>
            <div class="buttonholder">
                <button tam-button [tamType]=" 'primary' " [tamSize]=" 'normal' " class='admin-page-btn'
                    (click)="onButtonClick()"
                    *ngIf="currPage.additionalActions && currPage.additionalActions.create && !isSplitButton">
                    {{ currPage.additionalActions.create.buttonName }}
                </button>
                <tam-split-button [config]="splitButtonConfig"
                    *ngIf="currPage.additionalActions && currPage.additionalActions.create && isSplitButton">
                </tam-split-button>
            </div>
        </div>
    </div>
    <div class="grid-wrapper" loading-spin [isLoading]="loading" [loadingSize]="'big'">
        <div class="container">
            <div class="keyword-search">
                <aacl-keyword-search class="keyword-search" [options]="gridKeywordSearchConfig">
                </aacl-keyword-search>
            </div>
            <div class="entity-type-tips">
                {{currPage.description}}
            </div>
        </div>
        <ag-grid-angular style="height:100%" class="ag-theme-balham" [gridOptions]="gridOptions"
            [columnDefs]="columnDefs" [rowData]="rowData" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>
</div>